<template>
  <AppHeader />
  <main class="container"><slot /></main>
  <AppFooter />
</template>
